import {
  Component,
  computed,
  input,
  InputSignal,
  Signal,
  ViewEncapsulation,
} from "@angular/core";
import { LoadingModule } from "@components/loading";
import { BUTTON_VARIANT, SPINNER_STROKE } from "./button-cta.constants";

@Component({
  selector: "button[csButton]",
  imports: [LoadingModule],
  templateUrl: "./button-cta.component.html",
  exportAs: "csButton",
  styleUrl: "./button-cta.component.css",
  host: {
    "[class]": "classes()",
  },
  encapsulation: ViewEncapsulation.None,
  standalone: true
})
export class ButtonCtaComponent {
  csButton: InputSignal<string> = input("cta");
  size: InputSignal<string> = input();
  loading: InputSignal<boolean> = input(false);
  spinnerSize: InputSignal<number> = input(40);
  spinnerStrokeWidth: InputSignal<number> = input(3.2);

  classes: Signal<string> = computed(() => {
    let elmClasses = "cta-button";
    if (this.csButton() === BUTTON_VARIANT.MUTED) elmClasses += " cta-button-muted";
    if (this.csButton() === BUTTON_VARIANT.OUTLINED) elmClasses += " cta-button-outlined";

    if (this.size() === "small") elmClasses += " cta-small";
    return elmClasses;
  });

  spinnerStroke: Signal<string> = computed(() => {
    const variant = this.csButton();
    return variant === BUTTON_VARIANT.OUTLINED || variant === BUTTON_VARIANT.MUTED
      ? SPINNER_STROKE.TEAL
      : SPINNER_STROKE.DEFAULT;
  });
}
